import './bootstrap'
import Vue from 'vue'
import VueRouter from 'vue-router'
import moment from 'moment'
import router from './routes.js'
import App from './pages/App.vue'
import BootstrapVue from 'bootstrap-vue'
import i18n from './i18n'
import io from './socketio';
import VueProgress from 'vue-progress'
import firebase from "firebase/app";
import VueSocialSharing from 'vue-social-sharing'
import store from './store';
import 'firebase/analytics';


Vue.config.productionTip = false;

const configOptions = {
	apiKey: "AIzaSyB5dhUhb8D5fxcSwdBJkHhP4Kn2vyJAA28",
    authDomain: "adbalu-project.firebaseapp.com",
    databaseURL: "https://adbalu-project.firebaseio.com",
    projectId: "adbalu-project",
    storageBucket: "adbalu-project.appspot.com",
    messagingSenderId: "398095913611",
    appId: "1:398095913611:web:4d2766e5da91cfe80e7a8e",
    measurementId: "G-5NEBFJJZWR"
};

firebase.initializeApp(configOptions);
firebase.analytics();

Vue.use(VueSocialSharing);
Vue.use(BootstrapVue);
Vue.use(VueProgress)
Vue.use(VueRouter);
Vue.prototype.moment = moment;
Vue.prototype.io = io;
Vue.prototype.isElectron = window.isElectron;

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/firebase-messaging-sw.js');
}

const app = new Vue({
	el: '#app',
	i18n,
    store,
	router: router,
	render (h) {
    	return h(App) 
	}
});

export default app